import React from 'react'
import Header from './Header'
import Details from './sample'

const ProductDetails = () => {
  return (
    <div className='flex flex-col gap-5'>
        <Header />
        <Details />
    </div>
  )
}

export default ProductDetails